import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Chip } from "@mui/material";
import MainCard from "components/MainCard";
import { getControlPannelTitle, getEquipmentChipColorByType, getLogValueDescByCodeAndValue, groupAndDeduplicate, uniqueByEquipmentPartIdAndLogCode } from "data/data";


const StatusChip = ({measurementLogsLatest, opMode}) => {
    const { t } = useTranslation();

    const {
        controlPannels,
        controlPannelWithIaqs,
        controlExcludePannels
    } = useMemo(() => {
        if (!measurementLogsLatest) {
            return {
                controlPannels: [],
                controlPannelWithIaqs: [],
                controlExcludePannels: [],
            };
        }

        const controlUnits = measurementLogsLatest.filter(
            m => m.componentCode === 'controlUnit' && m.equipmentPartCode !== 'IAQSensor'
        );

        const controlUnitsWithIAQ = measurementLogsLatest.filter(
            m => m.componentCode === 'controlUnit' && m.equipmentPartCode === 'IAQSensor'
        );

        const controlExcludeUnits = measurementLogsLatest.filter(
            m => m.componentCode !== 'controlUnit'
        );

        return {
            controlPannels: uniqueByEquipmentPartIdAndLogCode(controlUnits),
            controlPannelWithIaqs: groupAndDeduplicate(controlUnitsWithIAQ, {
                groupBy: ['componentLocationCode', 'componentLocationName'],
                dedupeBy: ['equipmentPartId', 'logCode'],
            }),
            controlExcludePannels: groupAndDeduplicate(controlExcludeUnits, {
                groupBy: ['componentCode', 'componentName'],
                dedupeBy: ['equipmentPartId', 'logCode'],
            }),
        };
    }, [measurementLogsLatest]);

    if (!measurementLogsLatest?.length) return null;

    return (
        <div className='equipment_inbox2'>
            {controlPannels && controlPannels.length > 0 &&
            <MainCard content={false} className="squarebox">
                <div className='alert_phrase'>
                <div style={{display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <div style={{padding:"0 10px", textAlign:"center"}}>
                    {/* <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp; */}
                    <Chip label={t('message.common.subtitle.control')} color="primary" />
                    </div>
                </div>

                <div className="view_control_box">
                    {controlPannels && controlPannels.map((cp, idx)=>{
                        // console.log(cp)
                        const title = getControlPannelTitle(cp);
                        // const title = cp.componentLocationName+'-'+cp.equipmentPartName+'-'+cp.logName
                        let className = getEquipmentChipColorByType(cp.logCode);
                        
                        const isAL = cp.logCode === 'AL';
                        const isNumeric = !Number.isNaN(Number(cp.logValue));

                        if (cp.logCode === 'AL' && cp.logValue === '1')
                            className = 'in_red';
                        if (cp.logCode !== 'ENA' && cp.logCode !== 'OUTPUT' && 
                            (
                                !isAL || (
                                    isAL &&
                                    isNumeric 
                                        ? cp.logValue === '1'
                                        : true
                                )
                            )
                            // (cp.logCode !== 'AL' || (cp.logCode === 'AL' && cp.logValue === '1'))
                        ) {
                            if (process.env.REACT_APP_TEMPERATURE_VIEW_YN === 'Y' 
                                || (process.env.REACT_APP_TEMPERATURE_VIEW_YN === 'N' && (cp.logCode !== 'T' && cp.logCode !== 'T_SPT' && cp.logCode !== 'T_ST'))) {
                                const value = t(getLogValueDescByCodeAndValue('text', cp.logCode, cp.logValue, cp.equipmentPartCode, cp.componentLocationCode)?.value)
                                return (
                    <div key={idx} className={className}>{title} : {value} {cp.logUnit}</div>
                                )
                            }
                        }
                    })}
                    {opMode && (
                    <div className="in_gray">
                        {t('message.common.subtitle.opmode')} :
                        {opMode === 'Cooling'
                        ? t('message.common.text.opmode.cooling')
                        : opMode === 'Heating'
                        ? t('message.common.text.opmode.heating')
                        : opMode}
                    </div>
                    )}
                </div>
                </div>
            </MainCard>
            }

            {controlPannelWithIaqs && controlPannelWithIaqs.map((cpwi, idx)=>{
                // console.log(cpwi)
                return (
            <MainCard key={idx} content={false} className="squarebox">
                <div className='alert_phrase'>
                <div style={{display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <div style={{padding:"0 10px", textAlign:"center"}}>
                    {/* <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp; */}
                    <Chip label={cpwi.group.componentLocationName} color="primary" />
                    </div>
                </div>

                <div className="view_control_box">
                    {cpwi.items.map((item, idx2)=>{
                        // console.log(item)
                        let className = getEquipmentChipColorByType(item.logCode)
                        // let className = 'in_gray';
                        const title = item.logName;
                        // const title = item.componentLocationName+'-'+item.equipmentPartName+'-'+item.logName
                        const isAL = item.logCode === 'AL';
                        const isNumeric = !Number.isNaN(Number(item.logValue));

                        if (item.logCode === 'AL' && item.logValue === '1')
                            className = 'in_red';
                        if (item.logCode !== 'ENA' && item.logCode !== 'OUTPUT' && 
                            (
                                !isAL || (
                                    isAL &&
                                    isNumeric 
                                        ? item.logValue === '1'
                                        : true
                                )
                            )
                            // (item.logCode !== 'AL' || (item.logCode === 'AL' && item.logValue === '1'))
                        ) {
                            if (process.env.REACT_APP_TEMPERATURE_VIEW_YN === 'Y' 
                                || (process.env.REACT_APP_TEMPERATURE_VIEW_YN === 'N' && (item.logCode !== 'T' && item.logCode !== 'T_SPT' && item.logCode !== 'T_ST'))) {
                                const value = t(getLogValueDescByCodeAndValue('text', item.logCode, item.logValue, item.equipmentPartCode, item.componentLocationCode)?.value)
                                return (
                    <div key={idx2} className={className}>{title} : {value} {item.logUnit}</div>
                                )
                            }
                        }
                    })}
                </div>
                </div>
            </MainCard>
                )
            })}
            
            {controlExcludePannels && controlExcludePannels.map((cep, idx)=>{
                // console.log(cep)
                return (
            <MainCard key={idx} content={false} className="squarebox">
                <div className='alert_phrase'>
                <div style={{display: "flex", alignItems: "center", marginBottom: "10px"}}>
                    <div style={{padding:"0 10px", textAlign:"center"}}>
                    {/* <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp; */}
                    <Chip label={cep.group.componentName+' '+t('message.common.subtitle.status.info')} color="primary" />
                    </div>
                </div>

                <div className="view_control_box">
                    {cep.items.map((item, idx2)=>{
                        // console.log(item)
                        const title = getControlPannelTitle(item);
                        // const title = item.componentLocationName+'-'+item.equipmentPartName+'-'+item.logName
                        let className = getEquipmentChipColorByType(item.logCode);

                        const isAL = item.logCode === 'AL';
                        const isNumeric = !Number.isNaN(Number(item.logValue));

                        if (item.logCode === 'AL' && item.logValue === '1')
                            className = 'in_red';
                        if (item.logCode !== 'ENA' && item.logCode !== 'OUTPUT' && 
                            (
                                !isAL || (
                                    isAL &&
                                    isNumeric 
                                        ? item.logValue === '1'
                                        : true
                                )
                            )
                            // (item.logCode !== 'AL' || (item.logCode === 'AL' && item.logValue === '1'))
                        ) {
                            if (process.env.REACT_APP_TEMPERATURE_VIEW_YN === 'Y' 
                                || (process.env.REACT_APP_TEMPERATURE_VIEW_YN === 'N' && (item.logCode !== 'T' && item.logCode !== 'T_SPT' && item.logCode !== 'T_ST'))) {
                                const value = t(getLogValueDescByCodeAndValue('text', item.logCode, item.logValue, item.equipmentPartCode, item.componentLocationCode)?.value)
                                return (
                    <div key={idx2} className={className}>{title} : {value} {item.logUnit}</div>
                                )
                            }
                        }
                    })}
                </div>
                </div>
            </MainCard>
                )
            })}
            </div>
    )
}

export default StatusChip;